import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import messages from '../../../messages';

import { AdditionalDescriptionStyled, StyledAdditionalText } from './styled';

export const AdditionalText = () => {
  const {
    currentVariant: { additionalText, attributes },
  } = useProductDetailContext();

  return (
    <>
      {attributes.WithoutCellophane && (
        <AdditionalDescriptionStyled>
          <FormattedMessage {...messages.withoutCellophane} />
        </AdditionalDescriptionStyled>
      )}

      {attributes.DifferentPackaging && (
        <AdditionalDescriptionStyled>
          <FormattedMessage {...messages.differentPackaging} />
        </AdditionalDescriptionStyled>
      )}

      {additionalText && (
        <StyledAdditionalText
          dangerouslySetInnerHTML={{ __html: additionalText }}
        />
      )}
    </>
  );
};
